import { Input } from '@/components/ui/input'
import { Label, RequiredIndicator } from '@/components/ui/label'

interface OrganizationBrokerFieldsProps {
	idPrefix: string
	dataTestIdPrefix: string
	brokerHost: string
	brokerPort: string
	hostError?: string | null
	portError?: string | null
	disabled?: boolean
	onBrokerHostChange: (value: string) => void
	onBrokerPortChange: (value: string) => void
}

export function OrganizationBrokerFields({
	idPrefix,
	dataTestIdPrefix,
	brokerHost,
	brokerPort,
	hostError,
	portError,
	disabled = false,
	onBrokerHostChange,
	onBrokerPortChange,
}: OrganizationBrokerFieldsProps) {
	const hostId = `${idPrefix}-broker-host`
	const portId = `${idPrefix}-broker-port`

	return (
		<>
			<div className='flex flex-col gap-2'>
				<Label htmlFor={hostId}>Broker Host {RequiredIndicator}</Label>
				<Input
					id={hostId}
					data-testid={`${dataTestIdPrefix}-broker-host`}
					value={brokerHost}
					onChange={event => onBrokerHostChange(event.target.value)}
					placeholder='broker.example.com'
					disabled={disabled}
					aria-invalid={!!hostError}
					aria-describedby={hostError ? `${hostId}-error` : undefined}
				/>
				{hostError && (
					<p
						id={`${hostId}-error`}
						role='alert'
						data-testid={`${dataTestIdPrefix}-broker-host-error`}
						className='text-control text-destructive'>
						{hostError}
					</p>
				)}
			</div>
			<div className='flex flex-col gap-2'>
				<Label htmlFor={portId}>Broker Port {RequiredIndicator}</Label>
				<Input
					id={portId}
					data-testid={`${dataTestIdPrefix}-broker-port`}
					value={brokerPort}
					onChange={event => onBrokerPortChange(event.target.value)}
					placeholder='8883'
					inputMode='numeric'
					disabled={disabled}
					aria-invalid={!!portError}
					aria-describedby={portError ? `${portId}-error` : undefined}
				/>
				{portError && (
					<p
						id={`${portId}-error`}
						role='alert'
						data-testid={`${dataTestIdPrefix}-broker-port-error`}
						className='text-control text-destructive'>
						{portError}
					</p>
				)}
			</div>
		</>
	)
}
